import {Component} from "../../../gvf/js/component";

export class PanelComponent extends Component{
    ready(){
        super.ready();
        this.findMember("toggle").unbind().click(
            (ev)=>{
                ev.preventDefault();
                $(ev.currentTarget).closest(".js-panel").toggleClass("is-collapsed");
            }
        );
    }
}
